export var SelectionSide;
(function (SelectionSide) {
    SelectionSide[SelectionSide["Home"] = 1] = "Home";
    SelectionSide[SelectionSide["Draw"] = 2] = "Draw";
    SelectionSide[SelectionSide["Away"] = 3] = "Away";
})(SelectionSide || (SelectionSide = {}));
//# sourceMappingURL=SelectionSide.js.map